<div class="user-groups-settings-container">
  <div class="user-groups-settings-content">
    <div class="user-groups-settings-header flex justify-between items-center">
      <div class="user-groups-settings-title flex flex-row items-center">
        <img src="/assets/icons/users.svg" alt="Users" />
        <div class="title">User Groups</div>
      </div>
      <div>
        <a *ngIf="isAdmin" saAutomatedSelector="user-group__add-button" (click)="addUserGroup({})" class="button-add"
          >Add</a
        >
      </div>
    </div>
    <div>
      <mat-table
        #table
        (matSortChange)="sortTable($event)"
        [dataSource]="dataSource"
        matSort
        *ngIf="userGroups && userGroups.length; else placeholder"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let row" saAutomatedSelector="userGroup__name">{{ row.name || 'No Name' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="users">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Users</mat-header-cell>
          <mat-cell class="hello" *matCellDef="let row">
            <mat-chip-list *ngFor="let user of row.users">
              <mat-chip>{{ user.name }}</mat-chip>
            </mat-chip-list>
          </mat-cell>
        </ng-container>

        <div class="flex flex-wrap"></div>

        <ng-container matColumnDef="action">
          <mat-header-cell class="invisible" *matHeaderCellDef></mat-header-cell>
          <mat-cell class="grid justify-items-end" *matCellDef="let row"
            ><i class="material-icons cursor-pointer" (click)="addUserGroup(row)">edit</i></mat-cell
          >
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          saAutomatedSelector="userGroup__row"
          [automatedName]="row.name"
        ></mat-row>
      </mat-table>
    </div>
  </div>
</div>

<ng-template #placeholder>
  <h3 class="placeholder-text">No User Group Found</h3>
</ng-template>
